import { defineComponent as _defineComponent } from 'vue'
import { computed, useRoute, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useTranslate, useVuetify } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { useCreatorShop } from "@/store/creator-shop";
import { getGiftGuidesStore } from "@/store/gift-guides";
import { getProfilesStore } from "@/store/profiles";


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftGuideSlideGroup',
  props: {
  displayName: {
    type: String,
    required: true,
  },
  currentId: {
    type: String,
    required: false,
    default: "",
  },
  showAudience: {
    type: Boolean,
    required: false,
  },
  showProfile: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const { t } = useTranslate();
const amplitude = useAmplitude();
const route = useRoute();
const store = useStore();
const vuetify = useVuetify();

const MIN_NUM_OF_GIFT_GUIDES_MOBILE = 2;
const MIN_NUM_OF_GIFT_GUIDES_DESKTOP = 5;



const giftGuideIds = computed(() => {
  const giftGuideStore = getGiftGuidesStore(store);
  return (giftGuideStore.feeds[props.displayName]?.ids || []).filter((id: string) => id !== props.currentId);
});

const isSmall = computed(() => vuetify.breakpoint.smAndDown);

const showSeeAll = computed(() => {
  const numOfProductSets = giftGuideIds.value?.length;
  return vuetify.breakpoint.xsOnly
    ? numOfProductSets >= MIN_NUM_OF_GIFT_GUIDES_MOBILE
    : numOfProductSets >= MIN_NUM_OF_GIFT_GUIDES_DESKTOP;
});

const profileId = computed(() => getProfilesStore(store).getProfileByDisplayName(props.displayName)?.id);

const title = computed(() => {
  if (route.value?.name === "explore-displayName-giftguides-id") {
    return t("See more of my gift guides").value;
  }
  return t("Gift guides").value;
});

const referringComponent = computed(() => {
  const section = `${route.value?.name === "explore-displayName-giftguides-id" ? "related " : ""}gift guide carousel`;
  return amplitude?.getReferringComponentByPage(route.value?.name ?? "", section) ?? "";
});

const productSetAnalyticsEvents = () => {
  amplitude?.sendEvent("/page/publisher/view-all-product-sets", {
    "gift-guide": true,
  });
  getAmplitudeStore(store).setReferringComponent(
    amplitude?.getReferringComponentByPage(route.value?.name ?? "", "creator shop gift guide carousel") ?? "",
  );
  useCreatorShop().setReferringShopTab();
};

return { __sfc: true,t, amplitude, route, store, vuetify, MIN_NUM_OF_GIFT_GUIDES_MOBILE, MIN_NUM_OF_GIFT_GUIDES_DESKTOP, props, giftGuideIds, isSmall, showSeeAll, profileId, title, referringComponent, productSetAnalyticsEvents }
}

})